<template>
  <div>
    <md-tabs :md-active-tab="active" @md-changed="tabChangged">
      <md-tab class="product-tabs" :md-label="product.name" v-for="product in products" v-bind:key="product.sourceId" :id="'tab'+product.sourceId">
        <div class="md-layout form-bottom-line">
          <div class="md-layout-item md-size-100" v-if="reasonList && reasonList.length > 0">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 question-title">{{$t('what-are-reason')}}</div>
              <div class="md-error" v-if="productFaultInfo.reasonMsg&&productFaultInfo.reasonMsg[product.sourceId]">{{$t('please-select-one')}}</div>
              <div class="md-layout-item md-size-100" v-for="item in reasonList" v-bind:key="item.id">
                <md-checkbox class="reason-checkbox" v-model="reason[product.sourceId]" :value="item.code" v-on:change="change(product.sourceId)">
                  <!--{{product.masterId}} | {{item.code}} | -->{{item.text}}</md-checkbox>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-100" v-if="reason[product.sourceId]=='DEFECTIVE'">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 question-title">{{$t('which-part-defective')}}</div>
              <div class="md-error" v-if="productFaultInfo.faultCatMsg&&productFaultInfo.faultCatMsg[product.sourceId]">{{$t('please-select-one')}}</div>
              <div class="md-layout-item md-size-100" v-for="(cat, index) in product.faultCat" v-bind:key="index">
                <md-checkbox class="reason-checkbox" v-model="faultCat[product.sourceId]" :value="index" v-on:change="change(product.sourceId)">{{index}}</md-checkbox>
                <div class="md-layout-item md-size-40" v-if="faultCat[product.sourceId]==index&&cat&&cat.length>1">
                  <md-field style="margin-bottom:8px">
                    <label>{{$t('please-select-one')}}</label>
                    <md-select v-model="faultCode[product.sourceId]" v-on:input="change(product.sourceId)">
                      <md-option :value="fault.faultCode" v-for="fault in cat" v-bind:key="fault.id">{{fault.faultCodeDesc}}</md-option>
                    </md-select>
                  </md-field>
                  <div class="md-error" v-if="productFaultInfo.faultCodeMsg&&productFaultInfo.faultCodeMsg[product.sourceId]">{{$t('please-select-one')}}</div>
                </div>
              </div>
              <!-- Show text input for last checkbox -->
              <div class="md-layout-item md-size-100" v-if="faultCat[product.sourceId]&&faultCat[product.sourceId]==faultCatLastItem[product.sourceId]">
                <div class="md-error" v-if="productFaultInfo.otherCommentsMsg&&productFaultInfo.otherCommentsMsg[product.sourceId]">{{$t('enter-comments')}}</div>
                <md-field>
                  <label>{{$t('comments')}}</label>
                  <md-textarea v-model="otherComments[product.sourceId]" md-counter="400" maxlength="400" v-on:change="change(product.sourceId)" style="min-height:60px;"></md-textarea>
                </md-field>
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-100" v-if="showUploadSection">
            <div class="md-layout">
              <div class="md-layout-item md-size-100 question-title">{{$t('cosmetic-damages')}}   </div>
              <div class="md-error" v-if="productFaultInfo.cosmeticMsg&&productFaultInfo.cosmeticMsg[product.sourceId]">{{$t('please-select-one')}}</div>
              <div class="md-layout-item md-size-100">
                <md-checkbox class="reason-checkbox" v-model="cosmetic[product.sourceId]" :value="true" v-on:change="change(product.sourceId)">{{$t('yes')}}</md-checkbox>
              </div>
              <div class="md-layout-item md-size-100" v-if="cosmetic[product.sourceId]==true">
                {{$t('attach-photo')}} <br /><span style="font-size:0.8em">({{$t('file-formats-allowed')}})</span>
                <div style="position:relative; overflow:hidden;" v-if="!damageImage[product.sourceId]||damageImage[product.sourceId].length==0">
                  <input type="file" v-on:input="upload($event, product)" style="position:absolute; z-index: 10; top:0; left: 0; font-size:100px;opacity:0;" />
                  <md-button class="md-accent md-raised upload-button">{{$t('choose-file')}}</md-button>
                </div>
                <div v-if="damageImage[product.sourceId] && damageImage[product.sourceId].length > 0">
                  <a :href="damageImage[product.sourceId]" target="_blank">
                    <span>Photo{{getFileExtension(damageImage[product.sourceId])}}</span>
                  </a>
                  <a href="javascript:;" v-on:click.stop="removeImage(product)" style="padding-top:10px;display:inline-block;padding-left: 4px;">{{$t('remove')}}</a>
                </div>
                <div class="md-error" v-if="productFaultInfo.damageImageMsg&&productFaultInfo.damageImageMsg[product.sourceId]">{{$t('upload-supporting-file')}}</div>
              </div>
              <div class="md-layout-item md-size-100" v-if="!needPOP[product.sourceId]">
                <md-checkbox class="reason-checkbox" v-model="cosmetic[product.sourceId]" :value="false" v-on:change="change(product.sourceId)">{{$t('no')}}</md-checkbox>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item" style="padding-top: 30px;">
              <div v-if="(store == 'jp')" v-html="$t('comment-describe')"></div>
              <div class="md-error" v-if="(productFaultInfo.commentsMsg&&productFaultInfo.commentsMsg[product.sourceId])">{{$t('enter-comments')}}</div>
              <md-field>
                <label>{{$t('comments')}}</label>
                <md-textarea v-model="comments[product.sourceId]" md-counter="2000" maxlength="2000" v-on:change="change(product.sourceId)"></md-textarea>
              </md-field>

              <div class="md-layout-item" v-show="(store == 'sg' || store == 'my' || store == 'au' || store == 'hk') && type == 'refund'" style="margin-bottom: 60px">
                <div class="md-layout-item md-size-100">
                  <md-checkbox class="reason-checkbox" v-model="returnAgree[product.sourceId]" v-on:change="change(product.sourceId)">
                    {{$t('acknowledge-return-product-in-original-packaging')}}

                    <span onclick="event.stopPropagation();">
                      <span v-if="store == 'sg' || store == 'my' || store == 'au' || store == 'hk'"><a :href="`https://${store}.creative.com/help/warranty-returns#what-39-s-your-return-policy-for-orders-placed-with-the-creative-store`" target="_blank" style="color: #2196f3;">Learn more &gt;</a></span>
                    </span>
                  </md-checkbox>
                </div>

                <div class="md-error" v-if="productFaultInfo.returnAgreeMsg == true && !returnAgree[product.sourceId]" style="margin:20px 0 0 0;">
                  Please acknowledge the above statement.
                </div>

              </div>
            </div>
          </div>
        </div>
      </md-tab>
    </md-tabs>
    <md-snackbar :md-active.sync="showUploadFormatMsg" :md-duration="8000">{{$t('file-formats-allowed')}}</md-snackbar>
    <md-snackbar :md-active.sync="showErrorMsg" :md-duration="8000">{{$t('encountered-error')}}</md-snackbar>

  </div>
</template>


<script>
  import { mapState, mapMutations } from 'vuex'
  import * as types from '../store/mutation-types'
  import Auth from '../mixins/auth'
  import { apiServer, imageServer } from '../config'
  export default {
    name: 'ReturnReason',
    components: {
    },
    props: {
      products: Array,
      type: String,
      active: String
    },
    computed: {
      ...mapState({
        store: 'store',
        step: 'step',
        productFaultInfo: 'productFaultInfo'
      })
    },
    data: () => ({
      loading: false,
      test: [],
      reasonList: [],
      reason: {},
      faultCode: {},
      cosmetic: {},
      needPOP: {},
      damageImage: {},
      comments: {},
      otherComments: {},
      returnAgree: [],
      faultList: [],
      faultCat: {},
      faultCatLastItem: {},
      showErrorMsg: false,
      showUploadFormatMsg: false,
      imageServer: imageServer,
      popFaultCode: {},
      showUploadSection: true,
      returnAgreeMsg: false
    }),
    created() {
      if (this.products && this.products.length > 0) {
        //1. Load reason list

        if (this.type == 'refund') {
          const firstProduct = this.products[0];

          if (firstProduct && firstProduct.faultList && firstProduct.faultList.length > 0) {
            this.reasonList = []

            // To block SG return reasons (Item cannot be defective if it's not open, coz return policy states package cannot be open)
            // So if not open, how will customer know it's DEFECTIVE .. lol, so disable "DEFECTIVE" selection option

            console.log(
              {
                products: this.products.map(p=>p.masterId),
                firstProduct: firstProduct.masterId
              }
            )

            if (this.store != 'hk' && this.store != 'sg' && this.store != 'my' || firstProduct.masterId === 24228)
              this.reasonList.push({id: 0, text: this.$t('product-is-defective'), code: 'DEFECTIVE' })

            let _store = this.store
            firstProduct.faultList.forEach(b => {
              if (b.display && b.faultCode.indexOf('NFF') == 0) {
                // window.console.log(_store)
                //To block SG/MY return reasons for the below return reason
                // NFF 09 - DEFECTIVE
                // NFF 01 - Product uncomfortable
                // NFF 02 - Problems with Software Application
                // NFF 05 - Product not up to expectations
                // NFF 06 - Product not compatible
                const blockReturnReason = ['NFF01', 'NFF02', 'NFF05', 'NFF06']

                if ((_store == 'sg' || _store == 'my') && firstProduct.masterId !== 24228) {
                  if (!blockReturnReason.includes(b.faultCode)) {
                    this.showUploadSection = false
                    this.reasonList.push({ id: b.id, text: b.faultCodeDesc, code: b.faultCode, needPOP: b.needPOP })
                  }
                }
                else  {
                  this.reasonList.push({ id: b.id, text: b.faultCodeDesc , code: b.faultCode, needPOP: b.needPOP })
                }
              }
            })
          }
        }
        // 2. Load fault code listing
        this.products.forEach(a => {
          a.faultCat = {}
          if (!this.popFaultCode[a.sourceId]) this.popFaultCode[a.sourceId] = []
          if (a.faultList && a.faultList.length > 0) {

            a.faultList.forEach(b => {
              if (b.display && b.faultCode.indexOf('NFF') != 0) {
                  if (!a.faultCat[b.faultCategory]) {
                    a.faultCat[b.faultCategory] = []
                    this.faultCatLastItem[a.sourceId] = b.faultCategory
                  }
                  a.faultCat[b.faultCategory].push(b)
                  if (b.needPOP) this.popFaultCode[a.sourceId].push(b.faultCode)
                //window.console.log(a.faultCat);
              }
            })
          }
          if (this.type == 'repair') this.reason[a.sourceId] = 'DEFECTIVE'
          else this.reason[a.sourceId] = ''
        })
      }
      //3. reset
      this.change()
    },
    methods: {
      ...mapMutations({
        updateFaultInfo: types.CHANGE_FAULT_INFO,
        showLoading: types.SHOW_LOADING,
        hideLoading: types.HIDE_LOADING,
        updateFaultMsg: types.CHANGE_FAULT_MSG
      }),
      change(sourceId) {
        if(sourceId && sourceId.length > 0 && this.faultCat && this.faultCat[sourceId] && this.faultCat[sourceId] == this.faultCatLastItem[sourceId]) {
          const product = this.products.find(a => { return a.sourceId == sourceId })
          if (product) {
            this.faultCode[sourceId] = product.faultCat[this.faultCat[sourceId]][0].faultCode
          }
        }

        let reasonMsg = {...this.productFaultInfo.reasonMsg}
        let faultCatMsg = {...this.productFaultInfo.faultCatMsg}
        let faultCodeMsg = {...this.productFaultInfo.faultCodeMsg}
        let otherCommentsMsg = {...this.productFaultInfo.otherCommentsMsg}
        let cosmeticMsg = {...this.productFaultInfo.cosmeticMsg}
        let damageImageMsg = {...this.productFaultInfo.damageImageMsg}
        let commentsMsg = { ...this.productFaultInfo.commentsMsg }

        if (sourceId && sourceId.length > 0) {

          if (this.reason && this.reason[sourceId] && this.reason[sourceId].length > 0)
            reasonMsg[sourceId] = false

          if (this.faultCode && this.faultCode[sourceId] && this.faultCode[sourceId].length > 0 ) {
            faultCatMsg[sourceId] = false
            faultCodeMsg[sourceId] = false
            // To detect specific fault code listing and force damaged file upload
            if (this.popFaultCode[sourceId] && this.popFaultCode[sourceId].includes(this.faultCode[sourceId]))
            {
              window.console.log("Damaged Photo needed in required FaultCode - " + this.faultCode[sourceId])
              this.cosmetic[sourceId] = true;
              this.needPOP[sourceId] = true;
            }
            else
            {
              this.needPOP[sourceId] = false;
            }
          }

          if (this.otherComments && this.otherComments[sourceId] && this.otherComments[sourceId].length > 0 )
            otherCommentsMsg[sourceId] = false

          if (this.store == 'jp' && !(this.comments[sourceId] && this.comments[sourceId].length > 0) ) {
            commentsMsg[sourceId] = true
          }

          if (this.cosmetic && this.cosmetic[sourceId] != undefined)
            cosmeticMsg[sourceId] = false
          if (this.damageImage && this.damageImage[sourceId])
            damageImageMsg[sourceId] = false
        }
        this.updateFaultInfo({
          reason: { ...this.reason },
          reasonMsg: { ...reasonMsg },
          faultCode: { ...this.faultCode },
          faultCatMsg: { ...faultCatMsg },
          faultCodeMsg: { ...faultCodeMsg },
          comments: { ...this.comments },
          otherComments: { ...this.otherComments },
          otherCommentsMsg: { ...otherCommentsMsg },
          cosmetic: { ...this.cosmetic },
          cosmeticMsg: { ...cosmeticMsg },
          damageImage: { ...this.damageImage },
          damageImageMsg: { ...damageImageMsg },
          commentsMsg: { ...this.commentsMsg },
          returnAgree: { ...this.returnAgree },
          returnAgreeMsg: { ...this.returnAgreeMsg }
        })
        //window.console.log('done')
      },
      upload(e, item) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          this.showUploadFormatMsg = true
          return
        }
        const name = files[0].name.toLowerCase()
        const ext = name.substr(name.lastIndexOf('.') + 1);
        //window.console.log(ext)
        if (['jpg','gif','png','pdf','webp', 'zip'].indexOf(ext)==-1) {
          this.showUploadFormatMsg = true
          return
        }
        this.showLoading()
        this.loading = true
      //  //window.console.log(files[0])
        let formData = new FormData()
        formData.append('file', files[0])
        formData.append('sourceId', item.sourceId)
        this.$http.post(`${apiServer}/api/your-request/upload-damage-image`, formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Authorization': `Bearer ${Auth.getToken()}`
            }
          }).then(({ data }) => {
            if (data.status == 'success' && data.url && data.url.length > 0)
              this.damageImage[item.sourceId] = data.url
            else {
              this.showErrorMsg = true
            }
            let damageImageMsg = { ...this.productFaultInfo.damageImageMsg }
            damageImageMsg[item.sourceId] = false
            this.updateFaultMsg({field: 'damageImageMsg', value: damageImageMsg})
            this.$forceUpdate()
            this.change()
            this.hideLoading()
            this.loading = false
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      removeImage(item) {
        this.showLoading()
        this.loading = true
        this.$http.post(`${apiServer}/api/your-request/remove-damage-image`, { ...item }, { headers: { Authorization: `Bearer ${Auth.getToken()}`, Member: Auth.getMemberToken() } }).then(({ data }) => {
          this.hideLoading()
          this.loading = false
          if (data && data.status && data.status == 'success') {
            this.damageImage[item.sourceId] = ''
            this.$forceUpdate()
            this.change()
          }
        }).catch(() => {
          this.hideLoading()
          this.loading = false
          this.showErrorMsg = true
        })
      },
      getFileExtension(url) {
        const ext = url.split(/#|\?/)[0].split('.').pop().trim()
        if (ext && ext.length > 0)
          return '.' + ext
        else
          return ''
      },
      tabChangged(id) {
        //window.console.log(id)
        this.$emit('tabChanged', id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";

  .reason-checkbox {
    margin: 8px 16px 0 0;
  }

  .question-title {
    margin: 10px 0;
  }
</style>